export default "__VITE_ASSET__BsBExWt___"